import React, { useState } from 'react';
import Modal from 'react-bootstrap/lib/Modal';
import Button from 'react-bootstrap/lib/Button';
import FormControl from 'react-bootstrap/lib/FormControl';

interface ConfirmModalProps {
  show: boolean;
  title: string;
  message?: string | React.ReactElement;
  okLabel?: string;
  cancelLabel?: string;
  enableEscape?: boolean;
  prompt?: {
    label: string;
    placeholder?: string;
    defaultValue?: string;
    minLength?: number;
    maxLength?: number;
  };
  onConfirm: (promptValue?: string) => void;
  onCancel: () => void;
  onDismiss: () => void;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  show,
  title,
  message,
  okLabel = 'Okay',
  cancelLabel = 'Cancel',
  enableEscape = true,
  prompt,
  onConfirm,
  onCancel,
  onDismiss,
}) => {
  const [promptValue, setPromptValue] = useState(prompt?.defaultValue || '');

  const handleConfirm = () => {
    onConfirm(prompt ? promptValue : undefined);
  };

  return (
    <Modal
      show={show}
      onHide={onDismiss}
      backdrop={enableEscape ? true : 'static'}
      keyboard={enableEscape}
      dialogClassName="confirm-modal"
      autoFocus={true}
      data-testid="confirm-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title data-testid="confirm-modal-title">{title}</Modal.Title>
      </Modal.Header>
      {message && <Modal.Body data-testid="confirm-modal-message">{message}</Modal.Body>}
      {prompt && (
        <Modal.Body>
          <label
            htmlFor="confirm-modal-prompt"
            data-testid="confirm-modal-prompt-label"
          >
            {prompt.label}
          </label>
          <FormControl
            id="confirm-modal-prompt"
            data-testid="confirm-modal-prompt"
            type="text"
            placeholder={prompt.placeholder || ''}
            value={promptValue}
            onChange={(e: React.FormEvent<FormControl>) => setPromptValue((e.target as HTMLInputElement).value)}
            minLength={prompt.minLength}
            maxLength={prompt.maxLength}
            autoFocus
          />
        </Modal.Body>
      )}
      <Modal.Footer>
        {cancelLabel && (
          <Button onClick={onCancel} data-testid="confirm-modal-cancel-button">
            {cancelLabel}
          </Button>
        )}
        <Button bsStyle="primary" onClick={handleConfirm} data-testid="confirm-modal-ok-button">
          {okLabel}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmModal;
